const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '不缓冲秒开播',
    desc: '全国 350+ CDN 加速节点，智能选择最优线路，点击即播无需等待。无论是高峰期还是深夜，小草影院始终为您提供流畅丝滑的观影体验，告别卡顿与加载圈。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费不收费',
    desc: '小草影院永久承诺不收取任何费用，无需注册会员、无需购买点卡、无需观看广告解锁。全站数万部影视资源全部免费开放，即点即看，真正零门槛观影。',
  },
  {
    icon: 'ri-device-line',
    title: '全平台无缝观影',
    desc: '电脑、手机、平板全设备适配，自动识别屏幕尺寸提供最佳观影界面。支持横屏全屏播放、记忆播放进度，切换设备也能接着看，观影不间断。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">小草影院的三大核心优势，为你打造极致免费观影体验。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="group text-center p-8 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-default"
            >
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-5">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}